module.exports = __webpack_public_path__ + "static/media/1021296.95474e60.png";